export enum TournamentPrizeTypeEnum {
  PIX = 'pix',
  OBJECT = 'object'
}

export const tournamentPrizeTypeEnumLabels = {
  [TournamentPrizeTypeEnum.PIX]: 'Pix',
  [TournamentPrizeTypeEnum.OBJECT]: 'Objeto',
}